const urlParamsApiFields = {
	lykilord: 'kw',
	einstaklingur_nafn: 'pn',
	einstaklingur: 'pid',
	hlutverk: 'prole',
	stadur: 'farm',
	stadarnafn: 'fname',
	tungumal: 'lng',
	safn: 'rep',
	vatnsmerki: 'wm',
	innsigli: 'se',
	timabil: ['dd_a', 'dd_z'],
	leit: 'q',
	tegund: 'dt',
	sida: 'page',
	efni: 'su',
	boggull: 'bundle',
	safnmark: 'shelfmark'
}

const helpers = {
	getApiParams: (searchParams, skip) => {
		let urlParams = [];

		// Möppum parametra úr urli yfir í parametra fyrir apa
		for (const key of searchParams.keys()) {
			if (!skip || skip.indexOf(key) == -1) {
				if (typeof urlParamsApiFields[key] == 'string') {
					urlParams.push(urlParamsApiFields[key]+'='+searchParams.get(key));
				}
				else {
					if (searchParams.get(key) && key in urlParamsApiFields) {
						let paramValue = searchParams.get(key).split(',');

						if (paramValue.length == 1) {
							paramValue.push(paramValue[0])
						}

						paramValue.forEach((item, index) => {
							urlParams.push(urlParamsApiFields[key][index]+'='+item);
						})
					}
				}
			}
		}
		return urlParams;
	},

	parseSearchParams: (paramStr) => {
		let params = {};

		paramStr = decodeURI(paramStr);

		if (paramStr.substr(0, 1) == '?') {
			paramStr = paramStr.substr(1);
		}

		if (paramStr.split('&').length > 0) {
			paramStr.split('&').forEach((item, i) => {
				if (item.split('=')[0]) {
					params[item.split('=')[0]] = item.split('=')[1];
				}
			});
		}

		return params;
	},

	searchParamString: (params) => {
		let searchParams = [];

		for (var param in params) {
			searchParams.push(param+'='+
				(Array.isArray(params[param]) ? (
					params[param].map((item) => item.id || item).join(',')
				) : params[param])
			);
		}

		return '?'+searchParams.join('&');
	},

	updateSearchParams: (paramStr, newParams) => {
		let currentParams = helpers.parseSearchParams(paramStr);

		for (var param in newParams) {
			currentParams[param] = newParams[param];
		}

		let searchParams = [];

		for (var param in currentParams) {
			if (currentParams[param] != undefined && currentParams[param] != '') {
				searchParams.push(param+'='+
					(Array.isArray(currentParams[param]) ? (
						currentParams[param].map((item) => item.id || item).join(',')
					) : currentParams[param])
				);
			}
		}

		return '?'+searchParams.join('&');
	},

	createSliderMarks: (minYear, maxYear) => {
		let ret = Array.from(Array(((maxYear-minYear)/50)+1).keys()).reduce(function(map, year) {
			let yearValue = year*50+minYear;
			map[yearValue] = yearValue;
			return map;
		}, {});

		return ret;
	},

	placeListToMap: (data) => {
		let ret = [];

		data.forEach(item => {
			if (item.farm && item.farm.lat && item.farm.lng) {
				ret.push(item.farm);
			}
		});

		return ret;
	}
}

export default helpers;